export default {
    company_agency: "Loja",
    extensions: "Formato",
    project_name: "Elanco School",
    user: "E-mail",
    welcome_to: "Bem-vindo(a) ao",
}